import { Box, Stack } from "@mui/material";
import { ActivityStatus, ExecutionPlanType } from "generated-graphql/graphql";
import { CompleteActivity } from "routes/Staff/Fulfillment/FulfillmentDetails/Activities/ActivityBottomToolbar/CompleteActivity";
import { Requeue } from "routes/Staff/Fulfillment/FulfillmentDetails/Activities/ActivityBottomToolbar/Requeue";
import { Activity } from "generated-graphql/graphql";
import { useCohortDetails } from "../../useCohortDetails";

type CohortActivityBottomToolbarProps = {
  activity: Activity;
};

export function CohortActivityBottomToolbar({
  activity,
}: CohortActivityBottomToolbarProps) {
  const { data } = useCohortDetails();

  // At this point, we are enabling completion whenever an
  // activity is considered "current", that is, it is not
  // in these statuses
  const isCurrent = ![
    ActivityStatus.NotStarted,
    ActivityStatus.StaffCompleted,
    ActivityStatus.Completed,
  ].includes(activity?.status);

  const canRequeue = isCurrent && activity?.status === ActivityStatus.Error;
  const skipResumeDialog = activity?.executionPlan === ExecutionPlanType.Human;

  const tags = data?.cohort?.currentWorkflow?.tags
    ?.map((t) => t.name)
    .join(", ");

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        justifyContent: "space-between",
        alignItems: "flex-start",
        mt: 2,
      }}
    >
      <Stack direction="row" spacing={1}>
        {canRequeue && (
          <Requeue
            activity={activity}
            context="cohort"
            tags={tags}
            refetchQueries={["GetCohort"]}
            showWarningPanel={!skipResumeDialog}
          />
        )}
      </Stack>
      {isCurrent && (
        <CompleteActivity
          activity={activity}
          context="cohort"
          tags={tags}
          refetchQueries={["GetCohort"]}
          showWarningPanel={
            activity?.status === ActivityStatus.Error ||
            activity.executionPlan === ExecutionPlanType.Automation
          }
        />
      )}
    </Box>
  );
}
